<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { mdiReceiptTextOutline } from "@mdi/js"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { WorkOrderRow } from "../../../../_logic/work-order-table-model"

  type Props = {
    row: WorkOrderRow
  }

  const { row }: Props = $props()
</script>

<span class="billed-credits-cell">
  <StatusTag
    variant="neutral"
    size="sm"
    label={row.billedCreditsLabel}
    color={row.billedCreditsColor}
    icon={mdiReceiptTextOutline}
    tooltipContent={row.billedCreditsTooltip}
    tooltipHtml={row.billedCreditsTooltipHtml}
    tooltipClassName={row.billedCreditsTooltipHtml ? RICH_TOOLTIP_CLASS : ""}
    disableTitle={true}
  />
  {#if row.billedCreditsPending}
    <StatusTag size="sm" label="Abrechnung ausstehend" color="orange" />
  {/if}
</span>

<style lang="less">
  .billed-credits-cell {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    align-items: center;
  }
</style>
